import { gql } from '@apollo/client';

export const SAVE_RESIDUAL_VALUE_GRID = gql`
  mutation saveResidualValueGrid($input: ResidualValueGridInput!) {
    saveResidualValueGrid(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_RESIDUAL_VALUE_GRID = gql`
  mutation deleteResidualValueGrid($id: Int!) {
    deleteResidualValueGrid(id: $id) {
      commandId
      correlationId
    }
  }
`;

export const UPDATE_RESIDUAL_VALUE_GRID_STATE = gql`
  mutation updateResidualValueGridState($id: Int!, $stateId: Int!) {
    updateResidualValueGridState(id: $id, stateId: $stateId) {
      commandId
      correlationId
    }
  }
`;

export const SAVE_RESIDUAL_VALUE_GRID_ITEMS_DETAILS = gql`
  mutation saveResidualValueGridItemsDetails(
    $gridId: Int!
    $items: [ResidualValueGridItemInput]
    $details: [ResidualValueGridDetailInput]
    $excludeDetailsForItemIds: [Int]
  ) {
    saveResidualValueGridItemsDetails(
      gridId: $gridId
      items: $items
      details: $details
      excludeDetailsForItemIds: $excludeDetailsForItemIds
    ) {
      commandId
      correlationId
    }
  }
`;

export const DUPLICATE_RESIDUAL_VALUE_GRID = gql`
  mutation duplicateResidualValueGrid($id: Int!) {
    duplicateResidualValueGrid(id: $id) {
      commandId
      correlationId
    }
  }
`;